import { initEventBus } from '@repo/single-spa';

export const eventBus = initEventBus();
